"use strict";

export default function () {
    document.addEventListener("click", (e) => {
        const items = document.querySelectorAll(".c-filtro-aventura__item");

        // Fecha todos
        if (!e.target.closest(".c-filtro-aventura__item")) {
            items.forEach((i) => i.classList.remove("open"));
            return;
        }

        // Abre o atual
        const current = e.target.closest(".c-filtro-aventura__item");
        items.forEach((i) => {
            if (i !== current) i.classList.remove("open");
        });
        current.classList.toggle("open");
    });
}
